import Vue from "vue";
import iView, { FormItem, Row, Col, Icon } from "iview";
import "iview/dist/styles/iview.css";
// @ts-ignore
import locale from "iview/dist/locale/en-US";
// @ts-ignore
import notices from "@/mixins/notices.js";
import LoadingSpinner from "@/components/loading_spinner.vue";
import FFIcon from "@/components/fficon.vue";
import StringDatePicker from "@/components/string_date_picker.vue";
import AffixHeader from "@/components/affix-header.vue";

Vue.use(iView, { locale });
Vue.mixin(notices);
Vue.component("LoadingSpinner", LoadingSpinner);
Vue.component("FFIcon", FFIcon);
Vue.component("AffixHeader", AffixHeader);
Vue.component("StringDatePicker", StringDatePicker);
// @ts-ignore
Vue.component("i-form-item", FormItem);
// @ts-ignore
Vue.component("i-col", Col);
// @ts-ignore
Vue.component("i-row", Row);
// @ts-ignore
Vue.component("i-icon", Icon);
